import React from 'react';
import { Box, Button, Grid, LinearProgress, Paper, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import PageHeader from '../../../components/page-header';
import { useBannerController } from './context/banner-controller';
import { useBannerState } from './context/banner-context';
import { SortableList } from '../components/sortable-list';
import { EmptyState } from '../../../components/empty-state';
import { BannerRow } from './components/banner-row';
import { BannerDrawer } from './components/banner-drawer';

export function BannerComponent() {
    const ctrl = useBannerController();
    const { banners, loading, drawer } = useBannerState();
    const publishedCount = banners.filter((b) => b.isPublished).length;

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Banners"
                    subtitle="Imagens de destaque do carrossel e do popup do portal. Arraste para alterar a ordem de exibição."
                    breadcrumbs={[{ label: 'Banners' }]}
                />
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                            <ViewCarouselIcon color="primary" />
                            <Box sx={{ minWidth: 0 }}>
                                <Typography variant="h6" noWrap>Banners do portal</Typography>
                                <Typography variant="caption" color="text.secondary" noWrap component="div">
                                    {banners.length} banner(s) · {publishedCount} publicado(s)
                                </Typography>
                            </Box>
                        </Box>
                        <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={() => ctrl.openDrawer()} sx={{ flexShrink: 0 }}>
                            Novo banner
                        </Button>
                    </Box>
                    {loading && <LinearProgress sx={{ mb: 1 }} />}
                    {!loading && banners.length === 0 ? (
                        <EmptyState icon={<ViewCarouselIcon />} message="Nenhum banner cadastrado" actionLabel="Cadastrar o primeiro banner" onAction={() => ctrl.openDrawer()} />
                    ) : (
                        <SortableList
                            items={banners}
                            getId={(b) => b.id}
                            onReorder={ctrl.handleReorder}
                            renderItem={(banner, dragHandle) => (
                                <BannerRow
                                    banner={banner}
                                    dragHandle={dragHandle}
                                    onEdit={() => ctrl.openDrawer(banner)}
                                    onDelete={() => ctrl.handleDelete(banner)}
                                    onTogglePublication={() => ctrl.handleTogglePublication(banner)}
                                />
                            )}
                        />
                    )}
                </Paper>
            </Grid>

            <BannerDrawer
                open={drawer.open}
                initial={drawer.banner}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeDrawer}
                onSave={ctrl.handleSave}
            />
        </React.Fragment>
    );
}
